<template>
  <div class="cp-product">
    <span v-if="sale" class="cp-product-sale-tag has-text-white has-text-weight-bold">SALE</span>
    <img class="cp-product-image" :src="image" @click="$emit('click')" />
    <div class="cp-product-detail has-text-center">
      <div class="cp-product-detail-title">
        <a :class="['is-size-6','has-text-centered','has-text-black']"
          @click="$emit('click')">
          <h6>Madam Ranee<br></h6>
          <span>{{title | cutWord }}</span>
        </a>
      </div>
      <div class="cp-product-detail-detail">
        <p :class="['is-size-6', 'has-text-grey-dark',{'hide-detail':otproduct}]">
          <span v-html="detail"></span>
        </p>
        <b-button
          style="margin-top:10px;"
          @click="$emit('click')" class="md-button-bg cp-product-detail-button is-hidden-touch"
          :class="[{'hide-detail':otproduct == false}]"
          >
          View
        </b-button>
      </div>
        <b-button
          @click="$emit('click')" class="md-button-bg cp-product-detail-button"
          :class="[{'hide-detail':otproduct == true}]"
          >
          View
        </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Product',
  props: {
    title: {
      type: String,
      required: true,
    },
    detail: {
      type: String,
      required: false,
    },
    image: {
      type: String,
      required: true,
    },
    sale: {
      type: Boolean,
    },
    price: {
      type: Number,
      default: 0,
    },
    discount: {
      type: Number,
      default: 0,
    },
    otproduct: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    formatComma(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    cutWord(v) {
      let temp = v;
      if (v.startsWith('Madam Ranee')) {
        temp = v.substr(12);
      }
      return temp;
    }
  },
};
</script>

<style lang="scss" scoped>
.hide-detail{
  display:none;
}
.show-detail{
  display:block;
}
.md-button-bg{
  padding: 5px 40px 5px 40px;
  background: url("../assets/img/home/button-menu-active.png");
  background-position: center;
}
.cp-product {
  width: 250px;
  margin-top: 20px;
  position: relative;
  padding-top: 40px;
  @media screen and (max-width: 900px) {
    padding-top: 0px !important;
    width:150px;
  }
  &-image {
    display: block;
    margin-bottom: -20px;
    margin-left: auto;
    margin-right: auto;
    // width: 120px;
    // height: 200px;
    cursor: pointer;
     @media screen and (max-width: 900px) {
       margin-bottom: 0px;
    }
  }
  &-detail {
    display: block;
    position: relative;
    &-title{
      margin-bottom:10px;
      height: 60px;
       @media screen and (max-width: 900px) {
        margin-top:20px;
        height: 100%;
      }
    }
    &-button{
      // position: absolute;
    }
    &-detail{
      margin-bottom:10px;
      height: 90px;
       @media screen and (max-width: 900px) {
        height: 100%;
      }
    }
  }
  &-sale-tag {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 50px;
    background-color: #ff0000;
    border-radius: 3px 4px 4px 3px;
    // border-left: 1px solid #ff0000;
    margin-left: 19px;
    position: absolute;
    border-radius: 30px;
    // padding: 0 10px 0 10px;
    // top: 0;

    &:before {
      // content: '';
      // position: absolute;
      // display: block;
      // left: -19px;
      // width: 0;
      // height: 0;
      // border-top: 19px solid transparent;
      // border-bottom: 19px solid transparent;
      // border-right: 19px solid #ff0000;
      // border-radius: 5px;
    }

    &:after {
      content: '';
      background-color: white;
      border-radius: 50%;
      width: 4px;
      height: 4px;
      display: block;
      position: absolute;
      left: -9px;
      top: 17px;
    }
  }

  &-price-section {
    display: flex;
  }

  &-discount {
    margin-right: 10px;
  }

  &-price-with-discount {
    position: relative;

    &::before {
      position: absolute;
      content: '';
      left: 0;
      top: 50%;
      right: 0;
      border-top: 1px solid;
      border-color: inherit;

      transform: rotate(-5deg);
    }
  }
}
</style>
